module.exports = __WEBPACK_EXTERNAL_MODULE_57__;


//////////////////
// WEBPACK FOOTER
// external "baglass/core-client/js/core-client/ui/properties/PropertyUIControl"
// module id = 57
// module chunks = 0 1